import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs';
import { siteSpecificData } from '../../../environments/site-specific-data';
import { EntitySoftLabels } from '../models/entity-soft-labels';

const API_URL = siteSpecificData.apiUrlBase;

@Injectable()
export class SoftLabelsHttpService {
  constructor(private http: HttpClient) { }

  getEntitySoftLabels(): Observable<EntitySoftLabels> {
    const entitySoftlabelsUrl = `${API_URL}softlabels/entities`;
    return this.http
      .get<EntitySoftLabels>(entitySoftlabelsUrl).pipe(
        map(softlabels => softlabels || undefined)
      );
  }

}
